// Vendors
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
// Contexts
import { useAppInformationContextConsumerHook } from 'contexts/app-information.context';
import { useAppContextConsumerHook } from 'contexts/app.context';
// Constants
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_OFF,
} from '../constants/header-layout.constants';
// Event Handlers
import { HeaderLayoutHandlers } from '../handlers/header-layout.handlers';
import { HeaderLayoutTrackingHandlers } from '../handlers/header-layout.tracking.handlers';
import { LogHandlers } from 'handlers/log.handlers';
// Hooks
import { backButtonMustBeDisabled } from './utils/header-layout.hook.utils';
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { HeaderLayoutHookType } from './types/header-layout.hook.type';

const useHeaderLayoutHook = (): HeaderLayoutHookType => {
  const [showDropModal, setShowDropModal] = useState<boolean>(false);

  const { formatMessage } = useIntl();

  const { currentState, onHeaderBackClick, setOnHeaderBackClick, backModalConfiguration } =
      useAppContextConsumerHook(),
    { informationFlags } = useAppInformationContextConsumerHook();

  const {
      handleTrackClickBack,
      handleTrackCancelButton,
      handleTrackCloseIcon,
      handleTrackOpenModal,
    } = useAppTrackingHook(HeaderLayoutTrackingHandlers),
    { handleSendCustomActionEvent } = LogHandlers();

  const handlers = HeaderLayoutHandlers({
    handleSendCustomActionEvent,
    handleTrackClickBack,
    handleTrackCancelButton,
    handleTrackCloseIcon,
    onHeaderBackClick,
    setOnHeaderBackClick,
    setShowDropModal,
  });

  useEffect(() => {
    localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_OFF);
    window.addEventListener('beforeunload', handlers.handleBeforeUnload);
    window.addEventListener('popstate', handlers.handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handlers.handleBeforeUnload);
      window.removeEventListener('popstate', handlers.handlePopState);
    };
  }, []);

  return {
    ...handlers,
    backModalConfiguration,
    disableBack: backButtonMustBeDisabled({ currentState, informationFlags }),
    formatMessage,
    handleTrackOpenModal,
    showDropModal,
  };
};

export { useHeaderLayoutHook };
